import { render } from "./RequestorInfo.vue?vue&type=template&id=1465ba09"
import script from "./RequestorInfo.vue?vue&type=script&lang=js"
export * from "./RequestorInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__